// Modules
import cn from 'classnames';

// Types
import type { TRadioProps } from './Radio.type';

// Styles
import styles from './styles.module.scss';

// Helpers
import { generateID } from '../../helpers/common';

// Constants
import { RADIO_DEFAULT_PROPS, RADIO_LABEL_POSITION } from './Radio.constant';

const Radio = (props: TRadioProps) => {
	const {
		block,
		checked,
		className,
		disabled,
		id,
		inputClassName,
		label,
		labelClassName,
		labelPosition,
		required,
		size = RADIO_DEFAULT_PROPS.size,
		...restProps
	} = props;
	const inputId = id || generateID();
	const isLeftLabel = labelPosition === RADIO_LABEL_POSITION.left;

	const radioCN = cn(styles.legion_radio, styles[size!], className, {
		[styles.block]: block,
		[styles.disabled]: disabled,
		[styles.left_label]: isLeftLabel,
	});
	const inputCN = cn(styles.radio_input, inputClassName);
	const labelCN = cn(styles.radio_label, labelClassName, {
		[styles.disabled]: disabled
	});

	return (
		<div className={radioCN}>
			<input
				id={inputId}
				type={'radio'}
				className={inputCN}
				disabled={disabled}
				checked={checked}
				required={required}
				{...restProps}
			/>
			{label && <label htmlFor={inputId} className={labelCN}>{label}</label>}
		</div>
	);
}

export default Radio;
